<template>
  <button class="booth-chat-btn" :class="item.css_class" @click="handleChat">
    {{ $t("chat.boothChat") }}
    <img :src="$images.mailWhite" alt="mail.svg" />
  </button>
</template>

<script>
export default {
  props: {
    item: Object,
  },
  methods: {
    handleChat() {
      let obj = {
        location: "public",
        loc_id: this.item.loc_id,
      };
      this.EventBus.$emit("chatProp", obj);
    },
  },
};
</script>

<style lang="scss" scoped>
.booth-chat-btn {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5em;
  font-family: "Roboto";
  font-size: 16px;
  font-weight: 500;
  color: white;
  padding: 20px 5px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  outline: none;
  background-color: var(--button-color-dark-blue);
  img {
    min-width: 15px;
    min-height: 15px;
  }
}
</style>